import React from "react";
import { useLanguage } from "../../../contexts/LanguageContext";
import { NewSesModel } from "./NewSesModel";
import { PrevSesModel } from "./PrevSesModel";

export const SelectSession = () => {
    const language = useLanguage();

    return (
        <>
            <div className={`container`}>
                <div className="card card-custom card-sticky gutter-b">
                    <div className="card-header mb-3">
                        <div className="card-title m-0">
                            <span className="card-label text-dark">
                                {language.CCMODE_SESSION_SELECT_SESSION}
                            </span>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-12 text-center my-5">
                                <PrevSesModel />
                            </div>
                            <div className="col-12 text-center my-5">
                                <NewSesModel />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
